import { AbstractControl, ValidatorFn } from '@angular/forms';

export function AutocompleteObjectValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (typeof control.value === 'string') {
            return { invalidAutocompleteObject: { value: control.value } };
        }
        return null; /* valid option selected */
    };
}
